var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M18,4.755a4.838,4.838,0,0,1-.672.963,4.962,4.962,0,0,1-1.214,1.024q.02.16.03.3a10.922,10.922,0,0,1-.772,4.184,11.017,11.017,0,0,1-4.385,5.448,11.528,11.528,0,0,1-6.863,1.254A7.88,7.88,0,0,1,0,16.333a7.684,7.684,0,0,0,5.5-1.585,3.788,3.788,0,0,1-3.491-2.589,2.348,2.348,0,0,0,.783.04,7.281,7.281,0,0,0,.883-.12,4.139,4.139,0,0,1-2.509-1.947A4.2,4.2,0,0,1,.743,8.286a3.526,3.526,0,0,0,1.665.5A4.3,4.3,0,0,1,.773,6.129a4.924,4.924,0,0,1,.451-2.4A12.612,12.612,0,0,0,5.509,6.941a8.875,8.875,0,0,0,3.361.7,4.492,4.492,0,0,1,.452-2.849,3.882,3.882,0,0,1,2.318-1.686A3.421,3.421,0,0,1,15.07,4.172a6.108,6.108,0,0,0,2.388-.883,3.623,3.623,0,0,1-1.645,2.127A10.434,10.434,0,0,0,18,4.754Z",
    transform: "translate(0 -2.999)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5f9eefe88b2ccd518ca28b93823587ee.svg";
export { ForwardRef as ReactComponent };